import { Link } from "@inertiajs/react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { bizminer_app_pillar_insight_scoring_category_path } from "@/routes";
import type { CategoryWithPeers } from "./scoring-types";

interface ScoringDataTableProps {
  competitorNames: string[];
  account_name: string;
  categories: CategoryWithPeers[];
  pillarTitle: string;
  pillarInsightId: number;
}

export function ScoringDataTable({
  competitorNames,
  account_name,
  categories,
  pillarTitle,
  pillarInsightId,
}: ScoringDataTableProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Competitive Comparison</CardTitle>
        <CardDescription>
          Detailed scoring comparison across all metrics
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow className="border-b border-border hover:bg-transparent">
              <TableHead>{pillarTitle} KPI</TableHead>
              <TableHead className="text-center bg-primary/20">
                {account_name}
              </TableHead>
              {competitorNames.map((competitor) => (
                <TableHead key={competitor} className="text-center">
                  {competitor}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {categories.map((category, rowIdx) => (
              <TableRow
                key={category.id}
                className={rowIdx % 2 === 0 ? "bg-muted/30" : "bg-transparent"}
              >
                <TableCell className="font-medium">
                  <Link
                    href={bizminer_app_pillar_insight_scoring_category_path(
                      pillarInsightId,
                      category.id,
                    )}
                    className="text-primary hover:underline cursor-pointer"
                  >
                    {category.name}
                  </Link>
                </TableCell>
                <TableCell className="text-center font-semibold bg-primary/20">
                  {category.account_score.toFixed(1)}
                </TableCell>
                {category.competitor_scores.map((score, idx) => (
                  <TableCell key={competitorNames[idx] ?? idx} className="text-center">
                    {score != null ? score.toFixed(1) : "–"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
